import React, { useEffect, useState } from 'react';
import { Button, Checkbox, TextField } from '@mui/material';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { getUsersList } from '../redux/actions/userActions';
import { assignEmployersToAccountManager } from '../redux/actions/employerActions';

const customModalStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 1000,
        marginTop: '2em'
    },
    content: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '8px',
        maxWidth: '40%',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
    },
};

const AssignManagerModal = ({ open, onClose, employerIds }) => {
    const dispatch = useDispatch();
    const [selectedAdminUserId, setSelectedAdminUserId] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    // const [adminUsers, setAdminUsers] = useState([]);

    // const userDetails = useSelector((state) => state.user.userDetails);
    const adminUserList = useSelector((state) => state.user.usersList);

    useEffect(() => {
        dispatch(getUsersList());
    }, []);

    // useEffect(() => {
    //     setAdminUsers(adminUserList.filter(user => user.id != userDetails?.adminUserId));
    // }, [adminUserList, userDetails])

    const handleAssignManagerToEmployers = async () => {
        if (selectedAdminUserId) {
            const payload = {
                'adminUserId': selectedAdminUserId,
                'adminUserName': adminUserList.find(u => u.id == selectedAdminUserId)?.name,
                'employerIds': employerIds
            }

            setIsSaving(true);
            await dispatch(assignEmployersToAccountManager(payload));
            setIsSaving(false);
            onClose();
        }

    }

    const handleSelectAdminUser = (adminUser) => {
        setSelectedAdminUserId(adminUser.id);
    }

    return (
        <>
            <ReactModal
                isOpen={open}
                onRequestClose={onClose}
                contentLabel="Assign Manager to Employers"
                style={customModalStyles}
            >
                <div>

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Assign Manager:</span>
                        <span style={{ marginLeft: '8px' }}>[<span style={{ color: '#1976d2', fontWeight: 'bold' }}>{employerIds.length}</span> Employers Selected]</span>
                    </div>

                    <div style={{}}>
                        {adminUserList?.map((adminUser) =>
                            <div
                                onClick={() => handleSelectAdminUser(adminUser)}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    padding: '8px',
                                    cursor: 'pointer',
                                    borderRadius: '4px'
                                }}>
                                <div style={{ flex: 1, marginLeft: '8px' }}>
                                    {adminUser.name}
                                </div>
                                <Checkbox
                                    style={{ alignSelf: 'flex-end' }}
                                    size='small'
                                    checked={selectedAdminUserId == adminUser.id}
                                />
                            </div>
                        )}
                    </div>

                    <div style={{ marginTop: '24px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ width: '120px' }}
                            size='small'
                            variant='outlined'
                            onClick={onClose}
                        >Cancel</Button>
                        <Button
                            style={{ marginLeft: '12px', width: '120px' }}
                            size='small'
                            variant='contained'
                            onClick={handleAssignManagerToEmployers}
                            disabled={!selectedAdminUserId}
                        >{isSaving ? 'Saving' : 'Save'}</Button>

                    </div>

                </div>
            </ReactModal>
        </>
    );
};

export default AssignManagerModal;
